<template>
    <div ref="accountModal" class="modal fade" :id="dialogId" role="dialog" :aria-labelledby="dialogId"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog-popout" role="document">
            <div class="modal-content">
                <div class="block block-themed block-transparent mb-0">
                    <div class="block-header bg-primary-dark">
                        <h3 class="block-title">{{title}}</h3>
                        <div class="block-options">
                            <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close">
                                <i class="fa fa-fw fa-times"/>
                            </button>
                        </div>
                    </div>
                    <div class="block-content">
                        <label>Source Account</label>
                        <a class="block block-bordered block-rounded block-link-shadow" href="javascript:void(0)">
                            <div
                                class="block-content block-content-full d-flex align-items-center justify-content-between">
                                <div class="item item-circle bg-body-light">
                                    <i class="fa fa-money-bill-alt fa-2x text-success"/>
                                </div>
                                <div class="ml-3 text-right">
                                    <p class="font-size-lg font-w600 mb-0">
                                        {{account.balance}} {{account.currency}}
                                    </p>
                                    <p class="text-muted mb-0">
                                        {{account.name}}
                                    </p>
                                </div>
                            </div>
                        </a>
                        <form>
                            <div class="form-group">
                                <label>Destination Account</label>
                                <select :class="{'is-invalid': errors.destination}"
                                        v-model="transaction.destination"
                                        class="form-control">
                                    <option
                                        v-if="destination.account_type === account.account_type && destination.id !== account.id"
                                        :value="destination.id" v-for="(destination, key) in accounts.data"
                                        :key="key">{{destination.name}} ({{destination.account_type}})
                                    </option>
                                </select>
                                <div v-if="errors.destination" :class="['invalid-feedback']">
                                    {{errors.destination[0]}}
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Transfer Value</label>
                                <input :class="{'is-invalid': errors.value}" v-model="transaction.value" type="text"
                                       class="form-control">
                                <div v-if="errors.value" :class="['invalid-feedback']">
                                    {{errors.value[0]}}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="block-content block-content-full text-right bg-light">
                        <button @click="transfer()" type="button" class="btn btn-success">Save Changes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import EventBus from "../../../../bus/events";

    export default {
        props: {
            dialogId: {type: String},
            title: String,
            account: Object
        },
        name: "TransferCredits",
        data() {
            return {
                transaction: {
                    destination: '',
                    value: '',
                }
            }
        },
        mounted() {
            $(this.$refs.accountModal).on('hidden.bs.modal', () => {
                this.transaction.value = '';
                this.transaction.destination = '';
            });
            EventBus.$on('billing-account-credited', (res) => {
                $(this.$refs.accountModal).modal('hide')
            })
        },
        computed: {
            ...mapGetters({
                errors: 'getAccountsErrors',
                accounts: 'getAccounts'
            })
        },
        methods: {
            transfer() {
                this.transaction.source = this.account.id;
                this.$store.dispatch('transferCredits', this.transaction)
            }
        }
    }
</script>
